// (C) Copyright 2025 Hewlett Packard Enterprise Development LP

import { Trans } from 'react-i18next'

import { GLCPHeaderAppsMenu, Typography } from '../../../components'
import { isCoP } from '../../../utils/feature-flag-utils'

import { MainAppData } from './MainAppData'
import { HPEResourcesMenu } from './HPEResourcesMenu'
import { CloudConsoleMenu } from './CloudConsoleMenu'
import { HPEGLAdministrationMenu } from './HPEGLAdministrationMenu'

const AppsMenuContent = () => {
  const AppsMenuData = [
    {
      title: (
        <Typography type="text" size="xsmall">
          <Trans i18nKey="common:app_navigation.cloud_consoles">
            Cloud Consoles
          </Trans>
        </Typography>
      ),
      menu: <CloudConsoleMenu />,
      isHidden: isCoP()
    },
    {
      title: (
        <Typography type="text" size="xsmall">
          <Trans i18nKey="common:app_navigation.hpe_gl_administration">
            HPE GreenLake Administration
          </Trans>
        </Typography>
      ),
      menu: <HPEGLAdministrationMenu />
    },
    {
      title: (
        <Typography type="text" size="xsmall">
          <Trans i18nKey="common:app_navigation.hpe_resources">
            HPE Resources
          </Trans>
        </Typography>
      ),
      menu: <HPEResourcesMenu />
    }
  ]
  return (
    <GLCPHeaderAppsMenu
      mainApp={<MainAppData />}
      appsData={AppsMenuData}
      testId="apps-menu"
    />
  )
}

export { AppsMenuContent }
